import { Link } from 'react-router-dom';

import { Box } from '@uptime/design-system/components/Box';
import { Toolbar } from '@uptime/design-system/components/Toolbar';
import TextLogo from '@uptime/shared/components/TextLogo';

const SidebarHeader = () => {
  return (
    <Toolbar>
      <Box
        component={Link}
        to="/"
        sx={{ textDecoration: 'none' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <TextLogo />
      </Box>
    </Toolbar>
  );
};

export default SidebarHeader;
